import CategoryService from '@/bundles/Category/services/CategoryService';
import { http } from '@/bundles/Http/factory/HttpFactory';
import ErrorMapper from '@/bundles/Http/mappers/ErrorMapper';

function categoryServiceFactory() {
  return new CategoryService(http, new ErrorMapper());
}

export const categoryService = categoryServiceFactory();
